const addProfileReducer = (state = {}, action) => {
    switch (action.type) {
      case "ADD_PROFILE": {
        return{
          ...state,
          addProfileSuccess: action.success
        }
      }
      case "ADD_PROFILE_ERR": {
        return{
          ...state,
          addProfileError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default addProfileReducer;
  